import * as r from "./references_files";
const defaultMenu = [
    {
        name: "Mannschaftssport",
        link: "/mannschaftssport",
        short: "Mannschaft",
        subcontent: [
            {
                name: "Badminton",
                link: "/mannschaftssport/badminton",
            },
            {
                name: "Basketball",
                link: "/mannschaftssport/basketball",
            },
            {
                name: "Fußball",
                link: "/mannschaftssport/fußball",
                subcontent: [
                    {
                        name: "1. Herren",
                        link: "/mannschaftssport/fußball/1-herren",
                    },
                    {
                        name: "2. Herren",
                        link: "/mannschaftssport/fußball/2-herren",
                    },
                    {
                        name: "3. Herren",
                        link: "/mannschaftssport/fußball/3-herren",
                    },
                    {
                        name: "1. Damen",
                        link: "/mannschaftssport/fußball/1-damen",
                    },
                    {
                        name: "Alte Herren",
                        link: "/mannschaftssport/fußball/alte-herren",
                    },
                    {
                        name: "Junior:innen",
                        link: "/mannschaftssport/fußball#junior-innen",
                        subcontent: [
                            {
                                name: "U19",
                                link: "/mannschaftssport/fußball/u19",
                            },
                            {
                                name: "U17.1",
                                link: "/mannschaftssport/fußball/u17-1",
                            },
                            {
                                name: "U17.2",
                                link: "/mannschaftssport/fußball/u17-2",
                            },
                            {
                                name: "U15.1",
                                link: "/mannschaftssport/fußball/u15-1",
                            },
                            {
                                name: "U15.2",
                                link: "/mannschaftssport/fußball/u15-2",
                            },
                            {
                                name: "U15-Juniorinnen",
                                link: "/mannschaftssport/fußball/u15-juniorinnen",
                            },
                            {
                                name: "U13",
                                link: "/mannschaftssport/fußball/u13",
                            },
                            {
                                name: "U12",
                                link: "/mannschaftssport/fußball/u12",
                            },
                            {
                                name: "U11",
                                link: "/mannschaftssport/fußball/u11",
                            },
                            {
                                name: "U10.1",
                                link: "/mannschaftssport/fußball/u10-1",
                            },
                            {
                                name: "U10.2",
                                link: "/mannschaftssport/fußball/u10-2",
                            },
                            {
                                name: "U9.1",
                                link: "/mannschaftssport/fußball/u9-1",
                            },
                            {
                                name: "U9.2",
                                link: "/mannschaftssport/fußball/u9-2",
                            },
                            {
                                name: "U8",
                                link: "/mannschaftssport/fußball/u8",
                            },
                            {
                                name: "U7",
                                link: "/mannschaftssport/fußball/u7",
                            },
                            {
                                name: "Bambini (U5/U6)",
                                link: "/mannschaftssport/fußball/bambini-u5-u6",
                            },
                        ]
                    },

                    {
                        name: "Infos zum Talentwerk",
                        link: "/mannschaftssport/fußball/infos-zum-talentwerk",
                    },
                    {
                        name: "Walking Football",
                        link: "/mannschaftssport/fußball/walking-football",
                    },
                ]
            },
            {
                name: "Volleyball",
                link: "/erlebnissport/sport-und-natur#beach-arena"
            }
        ]
    },
    {
        name: "Erlebnissport",
        link: "/erlebnissport",
        short: "Erlebnis",
        subcontent: [
            {
                name: "Fitness und Entspannung",
                link: "/erlebnissport/fitness-und-entspannung",
                subcontent: [{
                    name: "Bootcamp",
                    link: "/erlebnissport/fitness-und-entspannung#bootcamp",
                }, {
                    name: "Damengymnastik",
                    link: "/erlebnissport/fitness-und-entspannung#damengymnastik",
                }, {
                    name: "Fit bis ins hohe Alter",
                    link: "/erlebnissport/fitness-und-entspannung#fit-bis-ins-hohe-alter",
                }, {
                    name: "Fit in Form - Mama!",
                    link: "/erlebnissport/fitness-und-entspannung#fit-in-form-mama",
                }, {
                    name: "Fitness Gymnastik",
                    link: "/erlebnissport/fitness-und-entspannung#fitness-gymnastik",
                }, {
                    name: "Fitness Mix 60+",
                    link: "/erlebnissport/fitness-und-entspannung#fitness-mix-60",
                }, {
                    name: "Kampfsport / Boxen",
                    link: "/erlebnissport/fitness-und-entspannung#kampfsport-boxen",
                }, {
                    name: "Pilates",
                    link: "/erlebnissport/fitness-und-entspannung#pilates",
                }, {
                    name: "Yoga",
                    link: "/erlebnissport/fitness-und-entspannung#yoga",
                }
                ]
            },
            {
                name: "Sport und Natur",
                link: "/erlebnissport/sport-und-natur",
                subcontent: [
                    {
                        name: "Beach-Arena",
                        link: "/erlebnissport/sport-und-natur#beach-arena",
                    }, {
                        name: "Beach-Tennis",
                        link: "/erlebnissport/sport-und-natur#beach-tennis",
                    }, {
                        name: "Bogenschießen",
                        link: "/erlebnissport/sport-und-natur#bogenschießen",
                    }, {
                        name: "MamaFitness-Outdoor",
                        link: "/erlebnissport/sport-und-natur#mamafitness-outdoor",
                    }, {
                        name: "Nordic Walking & Gymnastik",
                        link: "/erlebnissport/sport-und-natur#nordicwalking-und-gymnastik",
                    }, {
                        name: "Outdoor - Pilates",
                        link: "/erlebnissport/sport-und-natur#outdoor-pilates",
                    }, {
                        name: "Powergym & Walk im 7GB",
                        link: "/erlebnissport/sport-und-natur#powergym-und-walk-im-7gb",
                    }, {
                        name: "Radfahren",
                        link: "/erlebnissport/sport-und-natur#radfahren",
                    }, {
                        name: "Speedwalking",
                        link: "/erlebnissport/sport-und-natur#speedwalking",
                    }, {
                        name: "Sport im Park",
                        link: "/erlebnissport/sport-und-natur#sport-im-park",
                    }, {
                        name: "Streuobstwiesen Yoga",
                        link: "/erlebnissport/sport-und-natur#streuobstwiesen-yoga",
                    }, {
                        name: "Walking Football",
                        link: "/erlebnissport/sport-und-natur#walking-football",
                    }, {
                        name: "Wandern",
                        link: "/erlebnissport/sport-und-natur#wandern",
                    }
                ]
            },
            {
                name: "Turnen und Tanzen",
                link: "/erlebnissport/turnen-und-tanzen",
                subcontent: [
                    {
                        name: "Abenteuerturnen",
                        link: "/erlebnissport/turnen-und-tanz#abenteuerturnen",
                    }, {
                        name: "Breakdance",
                        link: "/erlebnissport/turnen-und-tanz#breakdance",
                    }, {
                        name: "Cheerleading",
                        link: "/erlebnissport/turnen-und-tanz#cheerleading",
                    }, {
                        name: "Eltern - Kind - Turnen",
                        link: "/erlebnissport/turnen-und-tanz#eltern-kind-turnen",
                    }, {
                        name: "Geräteturnen",
                        link: "/erlebnissport/turnen-und-tanz#geraeteturnen",
                    }, {
                        name: "Geschwisterturnen",
                        link: "/erlebnissport/turnen-und-tanz#geschwisterturnen",
                    }, {
                        name: "Inklusionssport für Kinder",
                        link: "/erlebnissport/turnen-und-tanz#inklusionssport-fuer-kinder",
                    }, {
                        name: "Tanzkurs",
                        link: "/erlebnissport/turnen-und-tanz#tanzkurs",
                    }, {
                        name: "Tu(s)gether - Kids",
                        link: "/erlebnissport/turnen-und-tanz#tu(s)gether-kids",
                    }, {
                        name: "Vorschulkinder",
                        link: "/erlebnissport/turnen-und-tanz#vorschulkinder",
                    }, {
                        name: "Zumba",
                        link: "/erlebnissport/turnen-und-tanz#zumba",
                    }, {
                        name: "Zumba - Kids",
                        link: "/erlebnissport/turnen-und-tanz#zumba-kids",
                    }
                ]
            }
        ]
    },
    {
        name: "Gesundheitssport",
        link: "/gesundheitssport",
        short: "Gesundheit",
        subcontent: [
            {
                name: "Firmenfitness",
                link: "/gesundheitssport/firmenfitness",
            },
            {
                name: "Prävention",
                link: "/gesundheitssport/praevention",
            },
            {
                name: "Rehabilitation",
                link: "/gesundheitssport/reha",
            }
        ]
    },
    {
        name: "Offene Ganztagsschule",
        link: "/ogs",
        short: "OGS",
        subcontent: [
            {
                name: "Am Sonnenhügel",
                link: "/ogs/am-sonnenhuegel",
            },
            {
                name: "Kule Kiste (13:00 Betreuung)",
                link: "/ogs/kule-kiste",
            },
            {
                name: "Oelberg Gymnasium",
                link: "/ogs/oelberg-gymnasium",
            },
            {
                name: "Anmeldung & Elternbeiträge",
                link: "/ogs/anmeldung-und-elternbeitraege",
            },
        ],
    },
    // {
    //     name: "Matchkalender",
    //     link: "/mannschaftssport/fußball#matchkalender"
    // },
    {
        name: "MamaPlus Programm",
        link: "/mama-plus-programm"
    },
    {
        name: "News",
        link: "/news"
    },
    // {
    //     name: "Fanartikel",
    //     link: "/#fanartikel"
    // },
    // {
    //     name: "Social Media",
    //     link: "/#social-media"
    // },
    {
        name: "Unser Verein",
        link: "/unser-verein",
        subcontent: [
            {
                name: "TuS-Organisation",
                link: "/unser-verein/tus-05-organisation",
                subcontent: [
                    {
                        name: "Geschäftsstelle",
                        link: "/unser-verein/tus-05-organisation#geschaeftsstelle"
                    },
                    {
                        name: "Vorstand",
                        link: "/unser-verein/tus-05-organisation#vorstand"
                    },
                    {
                        name: "Leitbild",
                        link: "/unser-verein/tus-05-organisation#leitbild"
                    },
                    {
                        name: "Jugendschutz",
                        link: "/unser-verein/tus-05-organisation#jugendschutz"
                    },
                    {
                        name: "Öffentlichkeitsarbeit",
                        link: "/unser-verein/tus-05-organisation#oeffentlichkeitsarbeit"
                    },
                    {
                        name: "Satzung & Mitgliederversammlung",
                        link: "/unser-verein/tus-05-organisation#satzung-und-mitgliederversammlung"
                    }
                ]
            },
            {
                name: "Sportstätten",
                link: "/unser-verein/sportstaetten"
            },
            {
                name: "Sportlerbar",
                link: "/unser-verein/sportlerbar"
            },
            {
                name: "Nachhaltigkeit beim TuS",
                link: "/unser-verein/nachhaltigkeit-beim-tus"
            },
            {
                name: "Ihr Engagement beim TuS 05",
                link: "/unser-verein/engagement-beim-tus"
            },
            {
                name: "Historie",
                link: "https://www.virtuelles-heimatmuseum.de/oberpleis/historie/abfrage_sql.php?rolle=ja&schublade=TuS%2005%20Oberpleis"
            }
        ]
    },
    {
        name: "Werde Teil von Uns!",
        link: "/werde-teil-von-uns",
        subcontent: [
            {
                name: "Mitgliedschaft / Flexkarten",
                link: "/werde-teil-von-uns#mitgliedschaft-oder-flexkarte"
            },
            {
                name: "Ehrenamt",
                link: "/werde-teil-von-uns#ehrenamt"
            },
            {
                name: "Schiedsrichter:in",
                link: "/werde-teil-von-uns#schiedsrichter-in"
            },
            {
                name: "Jugendförderverein",
                link: "/werde-teil-von-uns#jugendfoerderverein"
            },
            {
                name: "Stellenausschreibungen",
                link: "/werde-teil-von-uns#stellenausschreibungen"
            }
        ]
    },
    {
        name: "Unsere Sponsoren",
        link: "/sponsoren"
    },
    {
        name: "Service",
        link: "/service",
        subcontent: [

            {
                name: "Anmeldung: Camp",
                link: r.anmeldungCamp
            },
            {
                name: "Antrag auf TuS-Mitgliedschaft",
                link: r.mitgliedantragTuS
            },
            {
                name: "Antrag auf Mitgliedschaft beim Jugendförderverein",
                link: r.mitgliedantragJugendfoerderverein
            },
            {
                name: "Kursabmeldung",
                link: r.kursabmeldung
            },
            {
                name: "Sportangebot",
                link: "/service/sportangebot"
            },
            {
                name: "Terminkalender",
                link: "/service/terminkalender"
            },


            // {
            //     name: "Flexkarte bestellen",
            //     link: "/service/flexkarte-bestellen"
            // },

        ]
    },
    // {
    //     name: "Fragen?",
    //     link: "/#fragen"
    // },
    {
        name: "Gedenken",
        link: "/gedenken"
    }
];
const getLink = (name, menu = defaultMenu) => {
    if (name === 'Kontakt') {
        return "/kontakt"
    } else if (name === 'Datenschutz') {
        return "/datenschutz"
    } else if (name === 'Impressum') {
        return "/impressum"
    } else {
        for (const item of menu) {
            if (item.name === name) {
                return item.link; // Return the matching link
            }
            if (item.subcontent) {
                const result = getLink(name, item.subcontent);
                if (result) return result;
            }
        }
        return null;
    }
};

const getName = (link, menu = defaultMenu) => {
    if (link === '/kontakt') {
        return "Kontakt"
    } else if (link === '/datenschutz') {
        return "Datenschutz"
    } else if (link === '/impressum') {
        return "Impressum"
    } else {
        for (const item of menu) {
            if (item.link === link) {
                return item.name; // Return the matching name
            }
            if (item.subcontent) {
                const result = getName(link, item.subcontent);
                if (result) return result;
            }
        }
        return null;
    } // Return null if not found
};

export default defaultMenu;
export { getLink, getName };